<template>
    <section id="about">
      <p class="title">About</p>
      <vue-markdown-it
        class="content"
        v-if="about.body"
        :source="about.body"
      />
    </section>
</template>

<script>
import VueMarkdownIt from "vue-markdown-it";

export default {
  name: "About",
  props: [
    'about'
  ],
  components: {
    VueMarkdownIt
  },
  created() {
  },
  methods: {
  }
}
</script>

<style scoped>
#about {
  max-width: 350px;
}
div.content {
  padding-left: 20px;
  padding-right: 20px;
}
div.content :first-child {
  margin-top: 0px !important;
}
</style>


